import http from './http'

export default {
  searchClient(searchString) {
    return http.post('clients/findClient', {
      search: searchString,
    })
  },
}
